import { Directive, Output, EventEmitter, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDropzone]',
})
export class DropzoneDirective {
  borderImage = `<svg class="svg" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="100%"
        height="100%"
        fill="none"
        stroke="#$strokeColor" stroke-width="5" stroke-dasharray="15" stroke-dashoffset="6" stroke-linecap="square"
      />
    </svg>`;
  borderNormal = this.borderImage.replace('$strokeColor', 'DFDFDF');
  borderFocused = this.borderImage.replace('$strokeColor', '666666');

  @Output() filesChanged = new EventEmitter<any>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
    this.setBorder(this.borderNormal);
  }

  private setBorder(border: any) {
    this.renderer.setStyle(this.el.nativeElement, 'background-image', `url("data:image/svg+xml,${encodeURIComponent(border)}")`);
  }

  @HostListener('drop', ['$event']) public ondrop(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.filesChanged.emit(files);
    }
  }

  @HostListener('dragover', ['$event']) onDragOver(evt: any) {
    this.setBorder(this.borderFocused);
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
    this.setBorder(this.borderNormal);
    evt.preventDefault();
    evt.stopPropagation();
  }
}
